export const TIMESTEPS = [6, 12, 18, 24, 36, 48, 60, 72, 96];
